// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const primeReactConfig = { hideOverlaysOnDocumentScrolling: true };
const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, staleTime: 60_000 } },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No se encontró el elemento #root");
const root = ReactDOM.createRoot(rootEl);

root.render(
    <React.StrictMode>
      <PrimeReactProvider value={primeReactConfig}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PrimeReactProvider>
    </React.StrictMode>
);

reportWebVitals();
